const title = document.title || "机器之心 | 全球人工智能信息服务";
const descMeta = document.querySelector('meta[name="description"]');
const link = document.location.href;

const desc = descMeta ? descMeta.getAttribute("content") : "";

const defaultShare = {
  title,
  desc,
  link,
  imgUrl: "https://image.jiqizhixin.com/synced-share-icon.jpg",
};

const wechat = shareInfo => {
  const share = { ...defaultShare, ...shareInfo };

  // 构造 wx.config 的配置对象
  const config = {
    debug: process.env.NODE_ENV === "development",
    jsApiList: [
      "onMenuShareTimeline",
      "onMenuShareQQ",
      "onMenuShareWeibo",
      "onMenuShareAppMessage",
      "onMenuShareQZone",
    ],
  };

  // 如果路径中包含 "topics/"，则不添加 wxDefaultConfig
  if (!window.location.pathname.includes("topics/")) {
    Object.assign(config, wxDefaultConfig);
  }

  wx.config(config);
  wx.ready(() => {
    wx.onMenuShareTimeline(share);
    wx.onMenuShareQQ(share);
    wx.onMenuShareWeibo(share);
    wx.onMenuShareAppMessage(share);
    wx.onMenuShareQZone(share);
  });
};

export default wechat;
